import {
  getAttachment,
  downloadAttachment,
  getCategoryItems,
  refreshCategoryItems,
} from '../thunk';

import type { TableBaseColumnType, TableBaseRowType } from '@/components/TableBase/Body';
import type { NoticeItemJson } from '@/types/domain/notice/entities/noticeItemEntity';
import type { CategoryItemsType } from '@/types/domain/notice/redux';
import type { Dispatch } from 'redux';

import { LastModifiedDatetime } from '@/domain/notice/service/entity/valueObjects/lastModifiedDatetime';

/**
 * NoticeHistoryController
 */
export class NoticeHistoryController {
  private dispatch: Dispatch<any>;

  private categoryId: string;

  private itemList: NoticeItemJson[] = [];

  private nurseryId: string;

  private isEnableLoading: boolean;

  constructor(
    dispatch: Dispatch<any>,
    categoryId: string,
    categoryItems: CategoryItemsType | undefined,
    nurseryId: string,
  ) {
    this.dispatch = dispatch;
    this.categoryId = categoryId;
    const categoryItem = categoryItems && categoryItems[this.categoryId];
    this.itemList = (categoryItem && categoryItem.items) || [];
    this.nurseryId = nurseryId;
    this.isEnableLoading = Boolean(categoryItem && categoryItem.nextToken);
  }

  /** ROWS */
  get rows() {
    const items = this.itemList;
    const rows: { [key: string]: string }[] = [];
    for (let i = 0; i < items.length; i += 1) {
      // const cdate = CreateDatetime.create(new Date(items[i].createDatetime));
      const mdate = LastModifiedDatetime.create(new Date(items[i].lastModifiedDatetime));
      rows.push({
        // cdate: cdate.toStringDateDisplay(),
        mdate: mdate.toStringDateDisplay(),
        createDatetime: items[i].createDatetime,
        title: items[i].title,
      });
    }
    return rows;
  }

  /** Columns */
  get columns() {
    const columns: TableBaseColumnType[] = [
      { id: 'title', label: 'タイトル' },
      // { id: 'cdate', label: CreateDatetime.label },
      { id: 'mdate', label: LastModifiedDatetime.label },
    ];
    return columns;
  }

  /**
   * 追加読込可否を取得
   * @returns 追加読込可否
   */
  getIsEnableLoading = () => this.isEnableLoading;

  /**
   * 追加読込アクションを取得
   * @returns アクション
   */
  getActionGetItem = () => () => this.dispatch(getCategoryItems({
    nurseryId: this.nurseryId,
    categoryId: this.categoryId,
  }));

  /**
   * 再読込アクションを取得
   * @returns アクション
   */
  getActionRefreshItem = () => () => this.dispatch(
    refreshCategoryItems({ nurseryId: this.nurseryId }),
  );

  /**
   * プレビューアクションを取得
   * @returns アクション
   */
  getActionSetPreview = () => {
    const setPreview = (r: TableBaseRowType | undefined) => {
      if (r) {
        const item = this.itemList.find((v) => v.createDatetime === r.createDatetime);
        if (item) {
          this.dispatch(getAttachment({ item, nurseryId: this.nurseryId }));
          return;
        }
      }
      this.dispatch(getAttachment(undefined));
    };
    return setPreview;
  };

  /**
   * 閉じるアクションを取得
   * @returns アクション
   */
  getActionClose = () => () => this.dispatch(getAttachment(undefined));

  /**
   * ダウンロードアクションを取得
   * @returns アクション
   */
  getActionDownload = () => (r: TableBaseRowType) => {
    const item = this.itemList.find((v) => v.createDatetime === r.createDatetime);
    if (item) {
      this.dispatch(downloadAttachment({ item, nurseryId: this.nurseryId }));
    }
  };
}
